import ReferralsList from "components/referrals/ReferralsList";
import "./index.scss";
const Referrals = () => {
  return (
    <>
      <div className="main-contents">
        <h1 className="heading-h5">Referrals</h1>
        <ReferralsList />
      </div>
    </>
  );
};

export default Referrals;
